import React from 'react';
import Test from './Containers/Test';

export default function index({ locales, test }) {
  return <Test locales={locales} test={test} />;
}
